import "./SupportServices.module.css";
import Navigation from "@/reusable_sections/Header";
import Support from "./sections/Support";
import Process from "./sections/Process";
import Inquiries from "./sections/Inquiries";
import Footer from "@/reusable_sections/Footer";
export default function SupportServicesPage() {
  return <div>
      <Navigation />
      <Support />
      <Process />
      <Inquiries />
      <Footer />
    </div>;
}